module.exports = __webpack_public_path__ + "img/doc.1a5aea64.svg";